import React, { useEffect } from "react";
import CountUp from 'react-countup';
import { Box, Skeleton, Stack, styled, Typography } from '@mui/material';
import { useSelector } from "react-redux";
import { RootState } from "../store";
// import { testContract } from "../web3/contract";


const Root = styled('div')({

});

const Counts: React.FC = () => {

  // useEffect(() => {
  //   testContract();
  // }, []);

  const state = useSelector((state: RootState) => state.nft);


  return (
    <Root>

      {
        state.loading ? (
          <Stack direction="row" justifyContent="center">
            <Skeleton width={250} height={40} />
          </Stack>
        ) : (
          <React.Fragment>
            <CountUp start={0} end={state.totalSupply - state.circulatinSupply} delay={0}>
              {({ countUpRef }) => (
                <Stack direction="row" spacing={1} justifyContent="center" sx={{ mt: 2 }}>
                  <Typography variant="h5">Unique NFT's available:</Typography>
                  <Typography variant="h5" ref={countUpRef} />
                  <Typography variant="h5">of {state.totalSupply}</Typography>
                </Stack>
              )}
            </CountUp>
          </React.Fragment>
        )
      }
    </Root>
  );
};

export default Counts;